import { create } from "zustand";

interface AccountState {
  selectedAccountUuid: string | null;
  setSelectedAccountUuid: (uuid: string | null) => void;
}

export const useAccountStore = create<AccountState>((set) => ({
  selectedAccountUuid: null,
  setSelectedAccountUuid: (uuid) => set({ selectedAccountUuid: uuid }),
}));
